// extracted by mini-css-extract-plugin
export default {"root":"JobCard_root__i6Bxp","imageWrapper":"JobCard_imageWrapper__Ma0sj","image":"JobCard_image__jAZye","jobTitle":"JobCard_jobTitle__ygLil"};